import React, { useState,useEffect } from 'react'
import CustomPaginationTable from '../../components/Tables/paginationTable'
import { getAllmerchantsData, getSubscriptions } from '../../utils/firebase/firestore'
import { Grid, Typography } from '@mui/material';
import SkeletonTable from '../../components/Loaders/SkeletonTable';
import './merchant.css'

const MerchantsPage = () => {
  const [rows,setRows]=useState([]);
  const [search,setSearch]=React.useState("");
  const [isloading,setLoading]=useState(false);
  const columns = [
  // { id: "count", label: "#", minWidth: 100,align: "left", },
  { id: "name", label: "Store", minWidth: 100,align: "left", },
  { id: "planName", label: "Plan", minWidth: 100,align: "left", },
  { id: "status", label: "Status", minWidth: 100,align: "left", },
  {
    id: "createdAt",
    label: "Date of join",
    minWidth: 100,
    align: "left",
  },
  //value.toLocaleString('en-US')
  // {
  //   id: "email",
  //   label: "Email",
  //   minWidth: 100,
  //   align: "left",
  // },
  {
    id: "disabled",
    label: "Enable/Disable",
    minWidth: 100,
    align: "left",

  },
  {
    id: "code",
    label: "Registeration Code",
    minWidth: 100,
    align: "left",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "left",
  },
];
const formatRows = (input) => {
    let list=[];
    //[1,name,createdAt,email]
    let count=1
    for(let item of input){
      const {name,createdAt,email,registrationCode,disabled,planName,status}=item;
      list.push({count,name,createdAt,email,planName,status,code:registrationCode,disabled})
      count++;
    }
    const compare=(a,b)=>new Date(b.createdAt).getTime()-new Date(a.createdAt).getTime()
    list =list.sort(compare);
    setRows(list);
  };
  const [stores,setStores]=useState([])
  useEffect(() => {
   (async()=>{
    const list=await getAllmerchantsData();
    for(let item in list){
      const {data:subslist}=await getSubscriptions(list[item].name);
      if(subslist.length===0){
        if(new Date(list[item].endTrialDate).getTime()-new Date().getTime()>0){
          list[item].planName="Free Trial";
          list[item].status="active"
        }else{
          list[item].planName="Free Trial";
          list[item].status="finished"
        }
      }else{
        
        list[item].planName=subslist.filter(p=>p.statusSubscription=="active")[0]?.plan?.title||
        subslist.filter(p=>p.id==list[item].prevSubscriptionId)[0]?.plan?.title||
        "Not subscribed"
        list[item].status=subslist.filter(p=>p.statusSubscription=="active")[0]?.statusSubscription||
        subslist.filter(p=>p.id==list[item].prevSubscriptionId)[0]?.statusSubscription||
        "Not subscribed"
      }
    }
    // console.log(list,"dataa")
    setStores(list)
    formatRows(list)
   }
    )()
  
    
  }, [isloading])
  
  return (
    <div style={{
      display:"flex",
      justifyContent:"center",
      flexDirection:"column",
      alignItems:"center",
      width: "100%",
      // height:"100vh",
      margin:30
    }}>
      <div style={{
            width:"90%",
            display:"flex",
            alignItems:"center",
            justifyContent:"space-between",
            margin:"10px 0px"
        }}>
          <Typography variant="h6" style={{fontSize:30,alignSelf:"flex-start"}} >Stores</Typography>
        </div>
      {rows.length>0?<CustomPaginationTable 
        handleChange={setLoading}
        loading={isloading}
        setSearch={setSearch}
        rows={rows.filter(row=>(
          row.name.toLowerCase().match(new RegExp(search.toLowerCase().trim()))||
          row.code.toLowerCase().match(new RegExp(search.toLowerCase().trim()))||
          row.email?.toLowerCase().match(new RegExp(search.toLowerCase().trim()))
          ))}
        columns={columns}  />:
        <div style={{
          width:"90%"
        }}>
              <SkeletonTable loading/>
        </div>
      
      }
    </div>
  )
}

export default MerchantsPage